import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  makeRemoteGetEmailWhitelist,
  makeRemoteSetEmailWhitelist,
} from 'main/factories/usecases/bookkeeper/remote-email-whitelist';
import { Whitelist } from 'domain/usecases/email-whitelist';

export const useGetEmailWhitelist = (locationId: string | undefined) => {
  const getEmailWhitelist = makeRemoteGetEmailWhitelist();

  return useQuery({
    queryKey: ['emailWhitelist', locationId],
    queryFn: async () => {
      if (!locationId) return null;
      return getEmailWhitelist.get({ locationId });
    },
    enabled: !!locationId,
  });
};

export const useSetEmailWhitelist = (locationId: string | undefined) => {
  const queryClient = useQueryClient();
  const setEmailWhitelist = makeRemoteSetEmailWhitelist();

  return useMutation({
    mutationFn: async (payload: Whitelist) => {
      if (!locationId) throw new Error('Location ID is required');
      return setEmailWhitelist.set({ locationId, payload });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['emailWhitelist', locationId] });
    },
  });
};
